/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemLink } from "./d-theme-dark-menu-item-link";

export class DThemeDarkMenuSidedItemLink extends DThemeDarkMenuItemLink {}
